import './social-footer.css'
import './static/envelope.svg'
import './static/facebook.svg'
import './static/pinterest.svg'
import './static/twitter.svg'
